import ContentVisibility from './ContentVisibility'

const AttachmentDetail = `
  ${ContentVisibility}
  fragment AttachmentDetail on AttachmentDetail {
    contentLocale
    description
    id
    title
    url
    visibility {
      ...ContentVisibility
    }
  }
`

export default AttachmentDetail
